<template>
    <div class="wrap">
        <div class="container">
            <div class="addbook">
                <h3 class="personal_titile">
                    <van-row type="flex" align="center" justify="space-between">
                        <van-col>我的地址</van-col>
                        <van-col>
                            <router-link to="/addaddress">
                                <van-button size="mini" type="primary">新的地址</van-button>
                            </router-link>
                        </van-col>
                    </van-row>
                </h3>
                <van-radio-group v-model="selectaddress">
                    <van-row class="pay_reasss booklist bordernone" type="flex" align="center" justify="space-between" v-for="(value,index) in address_list" :key="index" @click="selectaddress = Number(value.id); checkAddress()">
                        <van-col>
                            <!-- <van-radio checked-color="#FE7A72" :name="Number(value.id)" @click="checkAddress"></van-radio> -->
                            <van-radio checked-color="#FE7A72" :name="Number(value.id)"></van-radio>
                        </van-col>
                        <van-col style="flex:1">
                            <div class="name"><span>{{value.name}}</span>T:{{value.tel}}</div>
                            <div>{{value.address}} {{value.address_line2}} {{value.city_name}} {{value.province_name}}
                                {{value.email}}</div>
                        </van-col>
                        <van-col>
                            <router-link class="ress_tz" :to="{path:'editaddress',query:{id:value.id}}">
                                <van-icon name="arrow" />
                            </router-link>
                        </van-col>
                    </van-row>
                </van-radio-group>

            </div>
        </div>
        <v-foot></v-foot>
    </div>
</template>
<style>

</style>
<script>
    export default {
        components: {},
        created() {
            this.getData();
            this.selectaddress = Number(this.$route.query.id);
            this.user_info = this.getUserInfo();
            localStorage.setItem('address_return_path','/selectaddress?id='+this.selectaddress)
        },
        data() {
            return {
                selectaddress: 0,
                address_list: [],
                user_info: false,
            }
        },
        methods: {
            getData(){
                var url = 'api/useraddress/index';
                var _self = this;
                this.GET(url,function (ret) {
                    if(ret.code === 0){
                        _self.address_list = ret.data;
                    }
                })
            },
            checkAddress(){
                if(!this.user_info){
                    this.$router.replace({path:localStorage.getItem('pay_path')})
                }else {

                    var url ="api/useraddress/SetDefault"
                    var _self = this;

                    this.POST(url,{id:this.selectaddress},function (ret) {
                        if(ret.code === 0){
                            _self.$router.replace({path:localStorage.getItem('pay_path')})
                        }else{
                            _self.$toast('error')
                        }
                    })
                }
            }
        },
    }
</script>